import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import './Oplata.sass'
import SectionTitle from '../../ui/SectionTitle/SectionTitle'
import getFieldRenderObject from '../../utils/newforms/render/getFieldRenderObject'
import { createForm } from '../../utils/newforms/createForm'
import StatusMessage, {
  useStatusMessage,
} from '../../ui/StatusMessage/StatusMessage'
import isFormValid from '../../utils/newforms/validation/isFormValid'
import getFormValues from '../../utils/newforms/getFormValues'
import FormRender from '../../utils/newforms/render/FormRender'
import Button from '../../ui/Button/Button'
import { functions } from '../../config/firebase'

function Oplata() {
  const location = useLocation()
  const [form, setForm] = useState(
    createForm({ formPattern: new OplataForm() })
  )
  const [showErrors, setShowErrors] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [statusMessage, setStatusMessage] = useStatusMessage()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get('fail') === '1') {
      setStatusMessage({
        show: true,
        type: 'fail',
        message: 'Оплата не завершена. Попробуйте ещё раз или выберите другую сумму.',
        closeAfter: 8000,
      })
    }
  }, [location.search])

  const onSubmit = (e) => {
    e.preventDefault()
    if (!isFormValid({ form })) {
      setStatusMessage({
        show: true,
        type: 'fail',
        message: 'Пожалуйста, укажите сумму оплаты',
        closeAfter: 5000,
      })
      return setShowErrors(true)
    }
    setShowErrors(false)
    setIsLoading(true)

    const values = getFormValues({ form })
    const initPayment = functions.httpsCallable('initPayment')

    initPayment({ amount: values.sum })
      .then(({ data }) => {
        if (data && data.paymentUrl) {
          window.location.href = data.paymentUrl
          return
        }
        throw new Error('empty payment url')
      })
      .catch((err) => {
        console.error(err)
        setIsLoading(false)
        setStatusMessage({
          show: true,
          type: 'fail',
          message:
            (err && err.message) ||
            'Не удалось начать оплату. Попробуйте позже.',
          closeAfter: 6000,
        })
      })
  }

  return (
    <div className="Oplata">
      <div className="DefaultContainer">
        <SectionTitle title="Оплата услуг" />
        <div className="Oplata-Container">
          <form onSubmit={onSubmit} className="OplataForm">
            <div className="Form-Fields">
              {statusMessage.show && (
                <StatusMessage
                  className="Site-StatusMessage"
                  type={statusMessage.type}
                  message={statusMessage.message}
                />
              )}
              <FormRender
                form={form}
                setForm={setForm}
                sections={[{ fields: ['sum'] }]}
                errors={showErrors}
              />
            </div>
            <div className="OplataForm-Buttons">
              <Button
                title="Оплатить"
                theme="primary"
                size={48}
                type="submit"
                onClick={onSubmit}
                isLoading={isLoading}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

class OplataForm {
  constructor() {
    this.sum = {
      field: {
        fieldId: 'sum',
        fieldType: 'input',
        inputType: 'text',
        label: 'Сумма, ₽',
        required: true,
      },
      render: getFieldRenderObject(),
    }
  }
}

export default Oplata
